/**
 * @generated SignedSource<<03043fb1a60f9018b83c0f4e6ed3477d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type deleteLibraryMaterialMutation$variables = {
  deleteLibraryMaterialId: any;
};
export type deleteLibraryMaterialMutation$data = {
  readonly deleteLibraryMaterial: {
    readonly id: string;
  } | null;
};
export type deleteLibraryMaterialMutation = {
  response: deleteLibraryMaterialMutation$data;
  variables: deleteLibraryMaterialMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deleteLibraryMaterialId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "deleteLibraryMaterialId"
      }
    ],
    "concreteType": "Material",
    "kind": "LinkedField",
    "name": "deleteLibraryMaterial",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteLibraryMaterialMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteLibraryMaterialMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8aa3d1d97bc8a35bb0038aea58eaa9ee",
    "id": null,
    "metadata": {},
    "name": "deleteLibraryMaterialMutation",
    "operationKind": "mutation",
    "text": "mutation deleteLibraryMaterialMutation(\n  $deleteLibraryMaterialId: UUID!\n) {\n  deleteLibraryMaterial(id: $deleteLibraryMaterialId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5201f73d93a275094a91526a5d21816c";

export default node;
